<template>
	<div class="content" style="height:100%">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">Realtime Maps</h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<iframe src="https://stat.hydrod.net" style="width: 100%; height: 600px; border: 0;"></iframe>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		components: {
		},
		data() {
			return {
				show: false,
				loaded: false,
				date_range: 7,
				sensorList: [],
				waterLevelList: [],
				rainGaugeList: [],
				popup: {
					title: "",
					description: ""
				}
			}
		},
		created() {
			this.getSensor();
		},
		methods: {
			getSensor(more = false) {
				this.$http.get(this.config.api + "/public/sensor/get_list").then(data => {
					this.loaded = true;
					this.sensorList = data.body.data
				})
			},
			openSensor(sensor) {
				this.popup.title = sensor.name;
				this.popup.description = sensor.description;
				this.popup.hash = sensor.hash;
				this.show = true;
				this.getData(7);
			},
			updateChart() {
				this.getData(parseInt(this.date_range));
			},
			getData(date) {
				this.waterLevelList = [["Date", "Water Level (m)"]];
				for(let i = 0; i< date;i++) {
					this.waterLevelList.push([`${(new Date()).getDate() + i} ${(new Date()).getMonth()} ${(new Date()).getFullYear()}`, parseFloat((Math.random()* 10 * 2).toFixed(2))])
				}
				// var self = this;

				// this.drawWaterLevel(this.waterLevelList);
				// this.drawRainGauge(this.rainGaugeList);
				setTimeout(() => {
					this.loaded = true;
					setTimeout(() => {
						this.drawWaterLevel(this.waterLevelList);
					}, 500)
				}, 500)
			},
			closeDialog() {
				this.show = false;
				this.loaded = false;
				document.getElementById("water_level").innerHTML = "";
				this.waterLevelList = [];
				this.rainGaugeList = [];
				this.popup = {
					title: "",
					description: ""
				}
			},
			drawWaterLevel(array) {
				var data = google.visualization.arrayToDataTable(array);
				var options = {
					title: "Water Level Sensor",
					legend: { position: 'bottom' },
					chartArea: { width: '86%', height: 150},
					pointSize: 3,
					colors: ['#003144', '#003144'],
					hAxis: {
						textStyle: {fontSize: 12},
						textPosition: "out",
						showTextEvery: 1,
						direction:-1,
						slantedText:true,
						slantedTextAngle:45
					}
				};
				var chart = new google.visualization.LineChart(document.getElementById("water_level"));
				chart.draw(data, options);
			},
		},
		mounted() {
			google.charts.load('current', { packages: ['corechart', 'bar'] });
			this.$refs.mapRef.$mapPromise.then((map) => {
				// const tonle = new google.maps.KmlLayer({map,
				// 	url: "https://traware.com/map/province.kml",
				// });
				// let stations = new google.maps.KmlLayer({map,
				// 	url: "https://traware.com/map/stations.kml",
				// });
				// stations.addListener('click', function(event) {
				// 	self.openStation(event);
				// });
			})
			// console.log(GmapMap);
			// let stations = new google.maps.KmlLayer({
			// 	url: "https://traware.com/map/stations.kml",
			// });
			// stations.setMap(map);
			// this.$refs.mapRef.$mapPromise.then((map) => {
			// })
			// setInterval(() => {
			// 	this.getData();
			// }, 1000)
		}
	}
</script>

<style>
	.popup {
		width: 100%;
		height: 100%;
		z-index: 3;
		top: 0;
		left: 0;
		position: fixed;
		background-color: rgba(0,0,0,0.5);
	}
	.popup-body {
		/* overflow: scroll; */
	}
	.popup-content {
		background-color: #FFF;
		overflow: scroll;
		border-radius: 5px;
		top: 25px;
		width: calc(100% - 32px);
		left: 16px;
		position: absolute;
		height: calc(100% - 50px);
	}
	@media only screen and (min-width: 1200px) {
		.popup-content {
			width: calc(100% - 500px);
			left: 250px;
			/* height: calc(100% - 200px);
			top: 100px; */
		}
	}
	/* #003144 */
	.md-textarea {
		min-height: 400px !important;
	}

	.md-list-item-text {
		line-height: 48px !important;
		padding: 0px 18px !important;
	}

	.el-tabs__item.is-active {
		color: #003144 !important;
	}

	.el-tabs__item:hover {
		color: #003144 !important;
	}

	.el-tabs__active-bar {
		background-color: #003144 !important;
	}

	.md-progress-bar-fill {
		background-color: #003144 !important;
	}

	.md-progress-bar {
		background-color: #3c7ab736 !important;
	}

	.md-title {
		letter-spacing: 0 !important;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
	.md-list-item-text {
		font-family: "Kantumruy", "Nunito";
	}
	.md-list.md-theme-default .md-selected .md-list-item-content, .md-list.md-theme-default .router-link-exact-active .md-list-item-content {
		color: #003144;
	}
	.wrapper {
		height: 100% !important;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container:after {
		background-color: #003144 !important;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container {
		border-color: #003144 !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Maps.vue